import { toastError } from '@components/Toast';

import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

import { printApiError } from '@utils/Util';

export const setCostingFilterField = (params) => async (dispatch) => {
	await dispatch({
		type: Types.SET_COSTING_FILTER_DATA,
		payload: params
	});
};

export const clearCosting = () => async (dispatch) => {
	await dispatch({
		type: Types.CLEAR_COSTING,
		payload: {}
	});
};

export const fetchCostingCount = (params) => async (dispatch) => {
	await ApiClient.GET('fetchCostingRequestCount', params).then((response) => {
		dispatch({
			type: Types.SET_COSTING_COUNT,
			payload: response.data
		});
	});
};

export const fetchCostingDetails =
	(id, query = null) =>
	async (dispatch) => {
		try {
			let params = `${id}`;
			if (query) {
				params += '?';
			}
			if (query?.fabricType) {
				params += `fabricType=${query?.fabricType}&`;
			}
			if (query?.status) {
				params += `status=${query?.status}&`;
			}
			const response = await ApiClient.GET('quoteRequest', params);
			dispatch({
				type: Types.FETCH_COSTING_DETAILS,
				payload: response.data
			});
		} catch (error) {
			dispatch({ type: Types.FETCH_COSTING_DETAILS_FAILURE });
			if (error.message) {
				toastError(error.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

export const fetchAllQuoteRequest =
	(params = '?page=0&size=15', merge) =>
	async (dispatch) => {
		await ApiClient.GET('fetchAllQuoteRequest', params)
			.then((response) => {
				dispatch({
					type: Types.FETCH_ALL_QUOTE_REQUEST_BY_STATUS,
					payload: { data: response.data, merge: merge }
				});
				return response;
			})
			.catch((err) => {
				return err;
			});
	};

const QUOTE_URL = {
	BUYER_DESIGN: 'fetchQuoteCount',
	DESIGN_STUDIO: 'fetchCostingRequestCount'
};

export const fetchQuoteCount = (type, params) => async (dispatch) => {
	try {
		await ApiClient.GET(QUOTE_URL[type], params).then((response) => {
			dispatch({
				type: Types.SET_QUONT_COUNT,
				payload: response.data
			});
		});
	} catch (error) {
		printApiError(error);
	}
};

export const setCostingActiveTab = (payload) => async (dispatch) => {
	await dispatch({
		type: Types.SET_COSTING_ACTIVE_TAB,
		payload: payload
	});
};

export const setActiveCompletedTab = (payload) => async (dispatch) => {
	await dispatch({
		type: Types.SET_ACTIVE_COMPLETED_TAB,
		payload: payload
	});
};

export const setActiveTabInfo = (tabInfo) => async (dispatch) => {
	await dispatch({
		type: Types.SET_ACTIVE_TAB_INFO,
		payload: tabInfo
	});
};

export const setUpdateProductItemInfo = (payload) => async (dispatch) => {
	await dispatch({
		type: Types.UPDATE_COSTING_ITEM_INFO,
		payload: payload
	});
};
